import { useState } from "react";
import classNames from "classnames";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import customParseFormat from "dayjs/plugin/customParseFormat";

import AscGenericCard from "../AscGenericCard/AscGenericCard";
import styles from "./AscBullpenCard.module.scss";
import { MoreIcon, PlayIcon } from "../../AscIcons";
import { DEFAULT_TIME_OPTIONS } from "../../AscInputFields/AscTimeInput/DefaultTimeOptions";
import AscAdminAction from "../../AscAdminAction/AscAdminAction";

dayjs.extend(relativeTime);
dayjs.extend(customParseFormat);

export interface AscBullpenCardProps {
  name: string;
  coverImageUrl?: string;
  theme?: "white" | "ghost";
  startTime?: string;
  date?: string;
  id?: string;
  endTime?: string;
  time?: string;
  showPlayButton?: boolean;
  showMenu?: boolean;
  onClick?: () => void;
  onOpenModalHandler?: (event: any) => void;
  onDelete?: () => void;
  onEdit?: () => void;
}

export default function AscBullpenCard({
  name,
  theme = "white",
  coverImageUrl,
  date,
  time,
  startTime,
  endTime,
  showPlayButton,
  showMenu,
  onClick,
  onOpenModalHandler,
  onDelete,
  onEdit,
}: AscBullpenCardProps) {
  const [showAction, setShowAction] = useState<boolean>(false);

  const formattedStartTime = dayjs(startTime).isValid()
    ? dayjs(startTime).format("HH:mm A")
    : startTime;

  const formattedEndTime = dayjs(endTime).isValid()
    ? dayjs(endTime).format("HH:mm A")
    : endTime;

  const handleOnEdit = () => {
    onEdit && onEdit();
    setShowAction(false);
  };

  const handleOnDelete = () => {
    onDelete && onDelete();
    setShowAction(false);
  };

  return (
    <AscGenericCard
      className={classNames(styles.ground, {
        [styles.showPlayButton]: showPlayButton,
        [styles.white]: theme === "white",
        [styles.ghost]: theme === "ghost",
      })}
      titleClassName={styles.cardTitle}
      bodyClassName={styles.cardBody}
      imageClassName={styles.cardImage}
      title={name}
      coverImageUrl={coverImageUrl}
      tags={[
        showMenu && (
          <>
            <MoreIcon
              className={styles.moreIcon}
              data-testid={"asc-skill-card-more-icon"}
              onClick={() => setShowAction(!showAction)}
            />
            {showAction && (
              <AscAdminAction
                option1={"Edit"}
                option2={"Delete"}
                clickOption1={handleOnEdit}
                clickOption2={handleOnDelete}
                className={styles.adminAction}
              />
            )}
          </>
        ),
      ]}
      onClick={onClick}
    >
      <div className={styles.playIconWrapper}>
        <span className={styles.playIconContainer} onClick={onOpenModalHandler}>
          <PlayIcon />
        </span>
      </div>
      <div className={styles.dateContent}>
        <span className={styles.dateLabel}>
          {dayjs(date).format("dddd[,] MMM D[,] YYYY")}
        </span>
        {time ? (
          <span className={styles.timeLabel}>
            {DEFAULT_TIME_OPTIONS.filter((val) => val.value === time)[0].label}
          </span>
        ) : (
          <span className={styles.timeLabel}>
            {formattedStartTime} - {formattedEndTime}
          </span>
        )}
      </div>
    </AscGenericCard>
  );
}
